import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { SettingsIcon, SaveIcon, CheckIcon } from 'lucide-react';
const Settings: React.FC = () => {
  const {
    user
  } = useAuth();
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [emailNotifications, setEmailNotifications] = useState(true);
  const [commentNotifications, setCommentNotifications] = useState(true);
  const handleSaveSettings = () => {
    // In a real app, this would save to Firebase
    setSuccessMessage('Settings saved successfully!');
    setTimeout(() => {
      setSuccessMessage(null);
    }, 3000);
  };
  return <div data-id="element-422">
      <h1 className="text-2xl font-bold text-navy mb-6 font-montserrat" data-id="element-423">
        Account Settings
      </h1>
      {successMessage && <div className="bg-green-50 text-green-700 p-4 rounded-md mb-6 flex items-center" data-id="element-424">
          <CheckIcon size={18} className="mr-2" data-id="element-425" />
          {successMessage}
        </div>}
      <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-426">
        <div className="mb-6" data-id="element-427">
          <h2 className="text-xl font-bold text-navy mb-4 font-montserrat flex items-center" data-id="element-428">
            <SettingsIcon size={20} className="mr-2" data-id="element-429" />
            Profile Information
          </h2>
          <div className="flex items-center mb-6" data-id="element-430">
            {user?.photoURL ? <img src={user.photoURL} alt={user.displayName || ''} className="w-16 h-16 rounded-full mr-4" data-id="element-431" /> : <div className="w-16 h-16 rounded-full bg-navy text-white flex items-center justify-center mr-4 text-xl" data-id="element-432">
                {user?.displayName?.charAt(0).toUpperCase() || 'U'}
              </div>}
            <div data-id="element-433">
              <h3 className="text-lg font-medium" data-id="element-434">{user?.displayName}</h3>
              <p className="text-gray-500" data-id="element-435">{user?.email}</p>
              <p className="text-sm text-gray-500 mt-1 capitalize" data-id="element-436">
                Role: {user?.role}
              </p>
            </div>
          </div>
          <p className="text-sm text-gray-500 mb-4" data-id="element-437">
            Your profile information is managed through your Google account.
          </p>
        </div>
        <div className="mb-6" data-id="element-438">
          <h2 className="text-xl font-bold text-navy mb-4 font-montserrat" data-id="element-439">
            Notification Preferences
          </h2>
          <div className="space-y-4" data-id="element-440">
            <div className="flex items-center" data-id="element-441">
              <input type="checkbox" id="emailNotifications" checked={emailNotifications} onChange={() => setEmailNotifications(!emailNotifications)} className="h-4 w-4 text-orange focus:ring-orange border-gray-300 rounded" data-id="element-442" />
              <label htmlFor="emailNotifications" className="ml-2 block text-gray-700" data-id="element-443">
                Email notifications for article updates
              </label>
            </div>
            <div className="flex items-center" data-id="element-444">
              <input type="checkbox" id="commentNotifications" checked={commentNotifications} onChange={() => setCommentNotifications(!commentNotifications)} className="h-4 w-4 text-orange focus:ring-orange border-gray-300 rounded" data-id="element-445" />
              <label htmlFor="commentNotifications" className="ml-2 block text-gray-700" data-id="element-446">
                Notify me when someone comments on my articles
              </label>
            </div>
          </div>
        </div>
        <div className="flex justify-end" data-id="element-447">
          <button onClick={handleSaveSettings} className="btn-primary flex items-center" data-id="element-448">
            <SaveIcon size={18} className="mr-2" data-id="element-449" />
            Save Settings
          </button>
        </div>
      </div>
    </div>;
};
export default Settings;